import { render, staticRenderFns } from "./OfficeLocations.vue?vue&type=template&id=85935208&scoped=true&"
import script from "./OfficeLocations.vue?vue&type=script&lang=js&"
export * from "./OfficeLocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85935208",
  null
  
)

export default component.exports